function isNumeric(value) {
  return /^\d+$/.test(value)
}


// START: Price - Cash
function getChargingPrice(charging, currentVariant) {
  if (currentVariant.chargings.length <= 0) {
    return 0
  }

  return charging
    .map(function (id) {
      let foundCharging = currentVariant.chargings.find(x => x.id == id)

      return parseInt(foundCharging?.price) ?? 0
    })
    .reduce((acc, accessory) => acc + accessory, 0)
}

function getEquipmentPrice(cv, currentVariant) {
  if (currentVariant.equipment_variants.length <= 0) {
    return 0
  }

  const equipmentVariants = currentVariant.equipment_variants ?? []

  return cv.map(function (id) {
    let variant = equipmentVariants.find(x => x.id == id)

    return parseInt(variant?.price) ?? 0
  }).reduce((acc, cv) => acc + cv, 0)
}

function getGuaranteePrice(order) {
  if (order?.guarantee_price <= 0) {
    return 0
  }

  const guaranteePrice = parseInt(order?.guarantee_price ?? 0)
  const guaranteePriceOutstandingDebt = parseInt(order?.guarantee_price_outstanding_debt ?? 0)

  if (typeof guaranteePriceOutstandingDebt !== 'number' || isNaN(guaranteePriceOutstandingDebt)) {
    return guaranteePrice
  }

  return guaranteePrice - guaranteePriceOutstandingDebt
}

// END: Price - Cash

// START: Price - Leasing
function getChargingLeasingPrice(accessory, currentVariant) {
  if (currentVariant.chargings.length <= 0) {
    return 0
  }

  return accessory
    .map(function (id) {
      let foundCharging = currentVariant.chargings.find(x => x.id == id)

      return parseInt(foundCharging?.price_leasing) ?? 0
    })
    .reduce((acc, accessory) => acc + accessory, 0)
}

function getEquipmentLeasingPrice(cv, currentVariant) {
  if (currentVariant.equipment_variants.length <= 0) {
    return 0
  }

  return cv.map(function (id) {
    let variant = currentVariant.equipment_variants.find(x => x.id == id)

    return parseInt(variant?.leasing_price) ?? 0
  }).reduce((acc, cv) => acc + cv, 0)
}

// END: Price - Leasing

// START: Security deposit - Leasing
function getChargingSecurityLeasingDeposit(accessory, currentVariant) {
  if (currentVariant.chargings.length <= 0) {
    return 0
  }

  return accessory
    .map(function (id) {
      let foundCharging = currentVariant.chargings.find(x => x.id == id)

      return parseInt(foundCharging?.security_deposit_leasing) ?? 0
    })
    .reduce((acc, accessory) => acc + accessory, 0)
}

// END: Security deposit - Leasing


export function getCurrentPrice(type, order, currentVariant, cartItems = []) {
  let price = 0

  if (type === 'cash') {
    price = parseInt(order?.configuration?.engine_transmission?.price ?? 0)
    price += parseInt(order?.configuration?.color?.price ?? 0)
    price -= getGuaranteePrice(order)
  } else if (type === 'leasing') {
    price = parseInt(order?.leasing_price_range?.monthly_payment ?? 0)
    price += parseInt(order?.configuration?.color?.price_leasing ?? 0)

    cartItems = cartItems.filter((ci) => ci.use_leasing_price && ci.use_leasing_price !== '0')
  }

  if (order?.configuration?.chargings !== undefined) {
    price += type === 'cash'
      ? Object.values(order?.configuration?.chargings).reduce((acc, charging) => acc + getChargingPrice(charging, currentVariant), 0)
      : Object.values(order?.configuration?.chargings).reduce((acc, charging) => acc + getChargingLeasingPrice(charging, currentVariant), 0)
  }

  if (order?.configuration?.extra_equipments !== undefined) {
    price += type === 'cash'
      ? Object.values(order?.configuration?.extra_equipments).reduce((acc, extraEquipment) => acc + getEquipmentPrice(extraEquipment, currentVariant), 0)
      : Object.values(order?.configuration?.extra_equipments).reduce((acc, extraEquipment) => acc + getEquipmentLeasingPrice(extraEquipment, currentVariant), 0)
  }

  if (cartItems.length > 0) {
    const priceKey = type === 'cash' ? 'price' : 'price_leasing'
    const cil = cartItems.length

    for (let i = 0; i < cil; i++) {
      if (isNumeric(cartItems[i][priceKey].raw)) {
        price += parseInt(cartItems[i][priceKey].raw)
      }
    }
  }

  return price
}

export function getSecurityDeposit(type, order, currentVariant, currentEngineAndTransmission, cartItems = []) {
  let price = 0

  if (type === 'cash') {
    price = parseInt(currentEngineAndTransmission?.security_deposit ?? 0)
  } else if (type === 'leasing') {
    price = parseInt(order.leasing_price_range?.security_deposit ?? 0)

    if (order?.configuration?.chargings !== undefined) {
      price += Object.values(order?.configuration?.chargings).reduce((acc, charging) => acc + getChargingSecurityLeasingDeposit(charging, currentVariant), 0)
    }

    cartItems = cartItems.filter((ci) => ci.use_leasing_price && ci.use_leasing_price !== '0')

    if (cartItems.length > 0) {
      const cil = cartItems.length

      for (let i = 0; i < cil; i++) {
        if (isNumeric(cartItems[i].security_deposit_leasing?.raw)) {
          price += parseInt(cartItems[i].security_deposit_leasing?.raw ?? 0)
        }
      }
    }
  }

  return price
}
